import React, { useState, useEffect, useRef, useMemo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import styles from './MobileHeader.module.scss';
import { ReactComponent as HouseIcon } from '../../assets/icons/House_01.svg';
import { ReactComponent as ListIcon } from '../../assets/icons/Text_Align_Left.svg';
import { ReactComponent as FlagIcon } from '../../assets/icons/Flag.svg';
import { ReactComponent as FlagGoalIcon } from '../../assets/icons/Flag.svg'; // Можно заменить на календарь
import { ReactComponent as SettingsIcon } from '../../assets/icons/Settings.svg';
import { ReactComponent as CalendarIcon } from '../../assets/icons/Calendar.svg';
import { triggerHaptic, hapticImpact } from '../../utils/haptics';

const MobileHeader = () => {
  const { pathname } = useLocation();
  const [isMoving, setIsMoving] = useState(false);
  const prevIndex = useRef(-1);

  // Реактивное состояние для модуля событий
  const [isEventsEnabled, setIsEventsEnabled] = useState(
    localStorage.getItem('module_events_enabled') === 'true'
  );

  useEffect(() => {
    const handleSettingsChange = () => {
      setIsEventsEnabled(
        localStorage.getItem('module_events_enabled') === 'true'
      );
    };
    window.addEventListener('settingsUpdated', handleSettingsChange);
    window.addEventListener('storage', handleSettingsChange);
    return () => {
      window.removeEventListener('settingsUpdated', handleSettingsChange);
      window.removeEventListener('storage', handleSettingsChange);
    };
  }, []);

  const navItems = useMemo(() => {
    const base = [
      { path: '/dashboard', icon: HouseIcon, label: 'Главная' },
      { path: '/transactions', icon: ListIcon, label: 'Бюджет' },
      { path: '/goals', icon: FlagGoalIcon, label: 'Цели' },
    ];

    if (isEventsEnabled) {
      base.push({ path: '/events', icon: CalendarIcon, label: 'События' });
    }

    base.push({ path: '/settings', icon: SettingsIcon, label: 'Профиль' });
    return base;
  }, [isEventsEnabled]);

  const activeIndex = navItems.findIndex(
    (item) => pathname === item.path || pathname.startsWith(`${item.path}/`)
  );

  const isValidPage = activeIndex >= 0;

  useEffect(() => {
    const shouldAnimate =
      prevIndex.current !== -1 && prevIndex.current !== activeIndex;
    prevIndex.current = activeIndex;

    if (shouldAnimate) {
      setIsMoving(true);
      const timer = setTimeout(() => setIsMoving(false), 200);
      return () => clearTimeout(timer);
    }
  }, [activeIndex]);

  return (
    <div className={styles.bottomNavWrapper}>
      <nav className={styles.bottomNav}>
        {isValidPage && (
          <div
            className={styles.indicator}
            style={{
              width: `${100 / navItems.length}%`,
              transform: `translateX(${activeIndex * 100}%)`,
            }}>
            <div
              className={`${styles.indicatorBubble} ${
                isMoving ? styles.indicatorBubble_moving : ''
              }`}
              style={{
                marginLeft: '-4px',
                marginRight: '-4px',
                width: 'auto',
                flexGrow: 1,
              }}></div>
          </div>
        )}

        {navItems.map((item) => {
          const isActive =
            pathname === item.path || pathname.startsWith(`${item.path}/`);

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`${styles.navItem} ${
                isActive ? styles.navItem_active : ''
              }`}
              onClick={() => {
                triggerHaptic(hapticImpact.light);
              }}>
              <div className={styles.iconWrapper}>
                <item.icon className={styles.icon} />
              </div>
              <span className={styles.label}>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};

export default MobileHeader;
